var myLatLng = { lat: 47.127296, lng: 7.612407 };
var mapEl = $('#filter-map');
var map;
var currentMarkers = [];

function initMap() {
	map = new google.maps.Map(mapEl[0], {
	  zoom: 13,
	  minZoom: 8,
	  center: myLatLng,
	  mapTypeControl: false,
	  scrollwheel: false,
	  streetViewControl: false,
	  styles: [{"featureType":"all","elementType":"geometry.fill","stylers":[{"weight":"2.00"}]},{"featureType":"all","elementType":"geometry.stroke","stylers":[{"color":"#9c9c9c"}]},{"featureType":"all","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#eeeeee"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#7b7b7b"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#b4d7f0"},{"visibility":"on"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#b4d7f0"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#070707"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]}]
	});

	addMarkers();
}

function addMarkers() {
	var markers = $('.agenda-list .filter-item:visible');

	$.each(currentMarkers, function(key, value) {
		value.setMap(null);
	});

	currentMarkers = [];

	$.each(markers, function(key, value) {
		var item = $(value);

		var icon = mapEl.attr('data-icon');
		var marker = new google.maps.Marker({
		  position: new google.maps.LatLng(item.data('lat'), item.data('long')),
		  map: map,
		  icon: icon,
		  url: item.find('.deep-link').attr('href')
		});

		currentMarkers.push(marker);
		
		google.maps.event.addListener(marker, 'click', function() {
		    window.location.href = this.url;
		});
	});
}

$(function() {
	if (mapEl.length) {
		initMap();
	}

	$('.filter').on('click', function(event) {
		addMarkers();
	});

	$(window).on('filtered', function(event) {
		setTimeout(function() {
			addMarkers();
		}, 350);
	});
});



/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/maps/filter-map.js
 **/